import { Controller } from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { UrduInput } from "../../../../Components/Shared/UrduInput";

export default function DescriptionsSection({ form }) {
  const { formData, control, validationErrors, handleChange } = form;

  return (
    <section data-field="description" className="pf-card">
      <h3 className="pf-section-title mb-5">Product Content</h3>

      <div className="space-y-4">
        <div>
          <label className="pf-label">Short Description (Marketing Blurb)</label>
          <textarea
            name="shortDescription"
            value={formData.shortDescription}
            onChange={handleChange}
            placeholder="Brief summary shown in listings"
            className="pf-textarea min-h-[72px] resize-y"
          />
          <UrduInput
            label="مختصر تفصیل"
            name="shortDescription_ur"
            value={formData.shortDescription_ur}
            onChange={handleChange}
            type="textarea"
            rows={2}
          />
        </div>

        <div data-field="description">
          <label className="pf-label">
            Full Technical Description <span className="text-red-500">*</span>
          </label>
          <div
            className={`quill-product ${
              validationErrors.description ? "border-red-500" : ""
            }`}
          >
            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <ReactQuill
                  theme="snow"
                  value={field.value || ""}
                  onChange={field.onChange}
                  placeholder="Write a detailed product description"
                  className="custom-quill"
                />
              )}
            />
          </div>
          {validationErrors.description && (
            <p className="text-red-500 text-xs mt-1">
              {validationErrors.description}
            </p>
          )}
          <div className="mt-3">
            <label
              className="block text-sm font-bold text-gray-800 mb-1.5 text-right"
              dir="rtl"
            >
              تفصیل
            </label>
            <div className="quill-product quill-ur-product">
              <Controller
                name="description_ur"
                control={control}
                render={({ field }) => (
                  <ReactQuill
                    theme="snow"
                    value={field.value || ""}
                    onChange={field.onChange}
                    placeholder="اردو میں تفصیل لکھیں..."
                    className="custom-quill"
                  />
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
